<!-- 销售订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2&&dataActionBox.actionType !=3">

                                            <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <!-- 日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]" @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" :isShowLong="false"
                                                    :isdisabled="formOneValue.isChange == 0
                                                        || dataActionBox.actionType == 2|| dataActionBox.actionType == 3
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)">
                                                </df-date>
                                                <!-- 检索方案 -->
                                                <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                    @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" :disabled="formOneValue.isChange == 0
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)
                                                        || dataActionBox.actionType == 2|| dataActionBox.actionType == 3">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append" icon="el-icon-search"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0) || dataActionBox.actionType == 2|| dataActionBox.actionType == 3">
                                                    </el-button>
                                                </el-input>
                                                <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                <el-select clearable size="mini" v-else-if="formOneValue.entityField == 'cmIntype'" @visible-change="(e)=>{selectChange(e,formOneValue.entityField)}" :disabled="formOneValue.isChange == 0
                                                        || dataActionBox.actionType == 3" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in lxList" :key="item.diName" :label="item.diName" :value="item.diName">
                                                    </el-option>
                                                </el-select>
                                                <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="(e)=>{selectChange(e,formOneValue.entityField)}" :disabled="formOneValue.isChange == 0
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)
                                                        || dataActionBox.actionType == 2|| dataActionBox.actionType == 3" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.value" :label="item.key" :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                <!-- 账期 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                                                    :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)" v-model="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                                <!-- string类型 -->
                                                <el-input @keyup.enter.native="nextFocus(formOneKey, formOneValue.focusField)" v-else :disabled="formOneValue.isChange == 0
                                                        || (sendDataInfo.woApplyDetails.length > 0 && formOneValue.isUpdate == 0)
                                                        || dataActionBox.actionType == 2|| dataActionBox.actionType == 3" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2|| dataActionBox.actionType == 3">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.isWms
                                                    == 1 ? '是' : '否' }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细操作 -->
                                    <el-form :inline="true" size="mini">
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 3">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">新增明细</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.woApplyDetails.length < 1">删除明细</el-button>

                                            <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                                (Alt+F1：新增明细</el-link>
                                            <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                                Alt+F2：删除明细)</el-link>
                                        </div>
                                        <!-- 明细信息 -->
                                        <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.woApplyDetails" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                            @selection-change="handleSelectionChange" border size="mini" :height="mxHeight">
                                            <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in  mxForm.jurconfigform " :key="formOneKey" v-if="formOneValue.isShow == 1"
                                                :min-width="120" :show-overflow-tooltip="formOneValue.fieldType != 'search'">
                                                <template slot-scope="scope">
                                                    <!-- 显示通用名称 -->
                                                    <el-input :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName'
                                                        && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable :disabled="formOneValue.isChange == 0
                                                            || dataActionBox.actionType == 3"
                                                        @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.nosetField, formOneValue.nosetField, formOneValue.setField)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.nosetField, formOneValue.nosetField, formOneValue.setField)" slot="append"
                                                            icon="el-icon-search">
                                                        </el-button>
                                                    </el-input>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.woApplyDetails[scope.$index][formOneValue.riftField])">
                                                            {{
                                                                sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <!-- 生产日期 -->
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                            {{
                                                                $common.getLocalTime(sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField])
                                                            }}
                                                        </span>
                                                    </span>
                                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'dcNum'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @change="doCheckPrice(2, scope.$index)" @input="calculatePrice(2, scope.$index)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]" :disabled="formOneValue.isChange == 0
                                                            || dataActionBox.actionType == 3">
                                                    </el-input>
                                                    <!-- 月限销数量 -->
                                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'ycNum'
                                                            && dataActionBox.actionType != 2 && formOneValue.isChange == 1
                                                            " :disabled="formOneValue.isChange == 0
        || dataActionBox.actionType == 3" @blur="changeData(formOneValue.entityField, scope.$index)" @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <el-input @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number" v-else-if="formOneValue.entityField == 'lowestPrice'
                                                            && dataActionBox.actionType != 2 && formOneValue.isChange == 1
                                                            " :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(2, scope.$index)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <span v-else>
                                                        {{
                                                            sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>

                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>

                <div class="foot">
                    <div>
                        <el-button v-if="(dataActionBox.actionType == 2|| dataActionBox.actionType == 3) && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                        </el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo',)" v-if="dataActionBox.actionType == 0">保存</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
                    </div>
                    <div v-if="footForm">
                        <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                            <el-form-item :label="itemV.chineseField" v-for="( itemV, itemK ) in  footForm " :key="itemK">
                                <el-button type="success">{{ itemV.entityField == 'totalMoney' ?
                                    $common.getDecimalInfo(3, sendDataInfo[itemV.entityField])
                                    : sendDataInfo[itemV.entityField] }}</el-button>
                                <!-- <el-button type="success">{{ itemV.entityField == 'totalMoney' ? sendDataInfo[itemV.entityField].toFixed(2)
                  : sendDataInfo[itemV.entityField] }}</el-button> -->
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchSchemeOther ref="SearchSchemeOther" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
    name: "desuLimit",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
    },
    data() {
        //这里存放数据
        return {
            lxList: [],
            currentComponent: "",
            historicalOrder: {
                cmName: "",
                cmId: "",
                bgmName: "",
                bgmId: "",
            },
            //--------------------
            showDialog: false,
            dialogList: [],
            focusIndex: "",
            dictionariesDatas: [], //配送方式
            detailRules: false, //规则
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                ssType: 0
            },
            inputel: "", //所有input对象
            detaislDataInfo: {},
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            // userOneList:[],
            selectedDetailsIndex: 0,
            // 缺货登记
            stockRegisterBox: false,
            stockRegisterData: {
                bgmId: "",
                bgmName: "",
                cmId: "",
                cmName: "",
                wolrRegnumber: "",
                wolrRemark: "",
            },
            storageRoomList: [], //库房
            // 特价申请
            priceApplicationBox: false,
            priceApplicationData: {
                bgmId: "", //商品
                bgmName: "",
                coId: "", //货主
                coName: "",
                wosaSalecus: "",
                cmId: "",
                cmName: "",
                wosaAppprice: "", // 申请售价
                wosaAppreason: "", // 申请原因
                batchno: "", // 批号
                expidate: "", // 	有效期
                wosaEnddate: "", // 申请截止日期
                wosaMinprice: "", // 最低售价
                prodate: "", // 	生产日期
                acType: 0, // 0自动提交，1手动提交
            },
            editDateilsIndex: "",
            giftsList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            cmId: "",
            ormId: "",
            coId: 0,
            seType: "",
            setField: "",
            seIndex: 0,
            levleId: 0,
            seWidth: "0",
            mxHeight: 0,
            isLoaded: false,
            pageType: "one",
            parentSearchData: {
                orderType: 0, //	订单类型0.药品1.器械
            },
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            DialogExtract: false, //提取
            exId: "",
            exTitle: "",
            exWidth: "",
            ppId: "orderId",
            ticket: 0,
            nextSearch: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.ssType"(nvl, ovl) {
            console.log(nvl);
            if (nvl == 0) {
                this.tabForm[0].jurconfigform.forEach(item => {
                    if (item.entityField == 'cmIntype') {
                        item.isShow = 1
                    } else if (item.entityField == 'cmName') {
                        item.isShow = 0
                    }
                })
            } else if (nvl == 1) {
                this.tabForm[0].jurconfigform.forEach(item => {
                    if (item.entityField == 'cmIntype') {
                        item.isShow = 0
                    } else if (item.entityField == 'cmName') {
                        item.isShow = 1
                    }
                })
            }

        }
    },
    //方法集合
    methods: {
        changeData(data, index) {
            if ((this.sendDataInfo.woApplyDetails[index].dcNum > this.sendDataInfo.woApplyDetails[index].ycNum)) {
                return
            }

        },
        getlxList() {
            this.$http.getCateDictionariesData({ ids: [38] }).then(res => {
                this.lxList = res.result
            })
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        Historical(url, title) {
            this.currentComponent = url
            if (this.currentComponent == 'historicalSalesOrder') {
                this.historicalOrder.cmName = this.sendDataInfo['cmName']
                this.historicalOrder.cmId = this.sendDataInfo['cmId']
            }
            if (this.sendDataInfo['woApplyDetails'].length > 0) {
                this.historicalOrder.bgmId = this.sendDataInfo['woApplyDetails'][this.selectedDetailsIndex].bgmId
                this.historicalOrder.bgmName = this.sendDataInfo['woApplyDetails'][this.selectedDetailsIndex].bgmName
            }
            this.$nextTick(() => {
                this.$refs[this.currentComponent].openBox(this.historicalOrder, title)
            })
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.priceApplicationData.wosaEnddate = time
                console.log(this.priceApplicationData.wosaEnddate)
            }
        },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e, type) {
            if (type == 'ssType') {
                if (this.sendDataInfo.ssType == 0) {
                    this.sendDataInfo.cmName = ""
                    this.sendDataInfo.cmId = ""
                } else if (this.sendDataInfo.ssType == 1) {
                    this.sendDataInfo.cmIntype = ""
                }
            }
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },

        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.woApplyDetails.length > 0) {
                }
                this.addDetail("sendDataInfo");
                return;
            }
            if (fField == "keydown") {
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        closeChild() {
            this.parentSearchData.bgmId = "";
            this.parentSearchData.bgmName = "";
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            console.log("index", index, this.dataActionBox.actionType)
            this.seIndex = index;
            if (this.dataActionBox.actionType == 3) return
            if (field == "keydown") {
                console.log(this.sendDataInfo.woApplyDetails[index])
                if (Number(this.sendDataInfo.woApplyDetails[index].dcNum) > Number(this.sendDataInfo.woApplyDetails[index].ycNum)) {
                    this.$message.error("月限销数量小于日限销数量！")
                    return
                }

            }

            if (field == "keydown") {
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    console.log(this.$refs["bgmName"])
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                this.addDetail("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus();
        },

        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.woApplyDetails.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.woApplyDetails.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.woApplyDetails.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.woApplyDetails.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },

        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.cmId == "") {
                return this.$message({
                    message: "请先选择销售单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.cmId);
        },

        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },

        //换行提示
        lineMessageBox(data) {
            console.log(data)
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        //触发提取
        openExtSearch(id) {
            this.exId = id;
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            console.log(this.sendDataInfo);
            if (val != "" || val != undefined) {
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        this.sendDataInfo.woApplyDetails = val.arrlistbychen;
                    } else {
                        if (key == 'opmName' && val[key] == null || key == 'depName' && val[key] == null || key == 'depId' && val[key] == null || key == 'opmId' && val[key] == null) {
                            this.sendDataInfo[key] = this.sendDataInfo[key]
                        } else if (val[key] == null || val[key] === "") {
                        } else {
                            this.sendDataInfo[key] = val[key];
                        }
                        if (
                            this.sendDataInfo[key] == null ||
                            this.sendDataInfo[key] == "null"
                        )
                            this.sendDataInfo[key] = "";
                        this.sendDataInfo.totalMoney = 0;
                        this.sendDataInfo.totalNumber = 0;
                        this.sendDataInfo.totalCount = 0;
                    }
                }
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    this.sendDataInfo.totalMoney += item.rrdPsmoney;
                    this.sendDataInfo.totalNumber += item.oldNum;

                });
                this.sendDataInfo.totalCount =
                    this.sendDataInfo.woApplyDetails.length;
                // let responseData = await this.$http.getOrderId({ ids: [val.psaiId] });
                // this.sendDataInfo.pisOrderauxinfVo = responseData.result;
                this.DialogExtract = false;
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0;
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                    this.nextFocus(0);
                });
            }
            this.parentSearchData.stId = this.sendDataInfo.stId;
            this.parentSearchData.cmId = this.sendDataInfo.cmId;
            this.parentSearchData.coId = this.sendDataInfo.coId;
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField, setField) {
            setTimeout(() => {
                this.showDialog = false
            }, 16.7)
            if (type == "salesName" || type == "caiAddress" || type == "recName") {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            if (setField != undefined) {
                this.setField = setField;
            }
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.nosField = nosField;
            // this.parentSearchData.bgmId = ''
            // this.parentSearchData.bgmName = ''
            if (type == "bgmName") {
                this.parentSearchData.stId = this.sendDataInfo.stId;
                this.parentSearchData.cmId = this.sendDataInfo.cmId;
                this.parentSearchData.coId = this.sendDataInfo.coId;
                if (!this.nextSearch)
                    this.parentSearchData.bgmName =
                        this.sendDataInfo.woApplyDetails[this.seIndex].bgmName;
                console.log(this.parentSearchData.bgmName);
                if (this.parentSearchData.bgmName) {
                    let fh = 0
                    if (this.parentSearchData.bgmName.indexOf(',') != -1) {
                        fh = ','
                    } else if (this.parentSearchData.bgmName.indexOf('，') != -1) {
                        fh = '，'
                    }
                    if (fh !== 0) {
                        const str = this.parentSearchData.bgmName
                        const list = str.split(fh)
                        this.parentSearchData.bgmName = list[0] || ''
                        console.log(list, list[1]);
                        this.parentSearchData.manufacturer = list[1] || ''

                    } else {
                        this.parentSearchData.manufacturer = ''
                    }
                } else {
                    this.parentSearchData.bgmName = ''
                    this.parentSearchData.manufacturer = ''
                }
                this.selectedDetailsIndex = this.seIndex;
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                );
                return;
            }
            this.parentSearchData[type] = this.sendDataInfo[type];

        },

        // 不可赋值字段
        noSetField(val) {
            let arr = this.nosField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        // 赋值字段
        paramValue(val) {
            console.log(val)
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex, this.fField);
            });
        },

        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        //检索带回数据,
        changeInputModel(val) {
            console.log(val, this.seType);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.$nextTick(() => {
                    addEventListener("keyup", this.keyUp); //创建监听键盘事件
                    if (val.nextSearchId) {
                        this.nextSearch = true;
                        this.parentSearchData.bgmId = val.bgmId;
                        this.parentSearchData.bgmName = val.bgmName;
                        this.openSearch(
                            val.nextSearchId,
                            this.seIndex,
                            "bgmName",
                            "",
                            "woadPnumber"
                        );
                        return;
                    }
                    this.nextSearch = false;
                    var type = ""
                    if (this.seType == "bgmName") {
                        // val.expidate = 1670601600000
                        let isPush = false
                        this.sendDataInfo.woApplyDetails.forEach(item => {
                            if (item.bgmId == val.bgmId) return isPush = true
                        })
                        if (isPush) {
                            this.$message.error("不能选择重复商品！")
                            return
                        }



                        console.log(val)
                        if (val.expidate == null || val.expidate == '' || val.expidate == undefined) {


                        } else {
                            if (val.expidate < this.$common.getNewDayTime()) {
                                this.tableNextFocus("bgmName", this.seIndex);
                                return this.$message({
                                    message: "该品种已过期，不允许销售!",
                                    type: "error",
                                });
                            }
                        }

                        val.costAmount = 0;
                        val.costMoney = 0;
                        //商品明细
                        let bgiTypeArr = [],
                            bgiRateArr = [];
                        this.sendDataInfo.woApplyDetails.forEach((v) => {
                            if (
                                v.bgiType &&
                                v.bgiType != null &&
                                v.bgiType != "null"
                            ) {
                                console.log(typeof v.bgiType);
                                bgiTypeArr.push(v.bgiType);
                            }
                            if (
                                v.outRate &&
                                v.outRate != null &&
                                v.outRate != "null"
                            ) {
                                bgiRateArr.push(v.outRate);
                            }
                        });
                        if (
                            val.bgiType &&
                            val.bgiType != null &&
                            val.bgiType != "null"
                        ) {
                            bgiTypeArr[this.seIndex] = val.bgiType;
                        }
                        bgiTypeArr.forEach((item, i) => {
                            if (item == null || item == "null")
                                bgiTypeArr.splice(i, 1);
                        });
                        this.$http
                            .checkScopeSale({
                                //校验明细商品
                                formId: this.mxForm.jciId, //表单ID
                                unitId: this.sendDataInfo.cmId, //销售单位ID
                                bgmId: [val.bgmId], //商品id
                                bgsId: val.bgsId?[val.bgsId]:[],
                                ormId: this.ormId, //     组织ID
                                salesId: this.sendDataInfo.salesId, // 对方业务员ID
                                bgiTypes: bgiTypeArr, //	药品类型
                                taxs: bgiRateArr, //	税率
                                recId: this.sendDataInfo.recId, //收货人
                            })
                            .then((res) => {
                                console.log(res);
                                // if (res && res.status == 200) {
                                let flag = -1
                                this.dialogList = res.result
                                if (this.dialogList != null && this.dialogList.length > 0) {
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    this.$set(
                                        this.sendDataInfo.woApplyDetails,
                                        this.seIndex,
                                        JSON.parse(JSON.stringify(val))
                                    );
                                    this.sendDataInfo.woApplyDetails[
                                        this.seIndex
                                    ].isTicket = Number(this.ticket);
                                    // this.noSetField(JSON.parse(JSON.stringify(val)))
                                    this.$nextTick(() => {
                                        this.$set(
                                            this.sendDataInfo.woApplyDetails[this.seIndex],
                                            "woadPnumber",
                                            0
                                        );
                                        this.$set(
                                            this.sendDataInfo.woApplyDetails[this.seIndex],
                                            "psmoney",
                                            0
                                        );
                                        this.$set(
                                            this.sendDataInfo.woApplyDetails[this.seIndex],
                                            "money",
                                            0
                                        );
                                        var setField = []
                                        if (this.setField) {
                                            setField = this.setField.split(",")
                                            setField.forEach(item => {
                                                if (item == "psprice") {
                                                    this.$set(
                                                        this.sendDataInfo.woApplyDetails[this.seIndex],
                                                        "psprice",
                                                        val.psprice
                                                    );
                                                } else {
                                                    this.$set(
                                                        this.sendDataInfo.woApplyDetails[this.seIndex],
                                                        "psprice",
                                                        0
                                                    );
                                                }
                                            })
                                        } else {
                                            this.$set(
                                                this.sendDataInfo.woApplyDetails[this.seIndex],
                                                "psprice",
                                                0
                                            );
                                        }

                                        this.parentSearchData.bgmId = "";
                                        this.parentSearchData.bgmName = "";
                                        this.tableNextFocus(this.fField, this.seIndex);
                                        this.selectedDetailsIndex = this.seIndex;
                                        let refsElTable = this.$refs.mxTableRef;
                                        refsElTable.clearSelection();
                                        refsElTable.toggleRowSelection(
                                            this.sendDataInfo.woApplyDetails[
                                            this.selectedDetailsIndex
                                            ]
                                        );
                                    });
                                } else {

                                    this.$set(
                                        this.sendDataInfo.woApplyDetails,
                                        this.seIndex,
                                        JSON.parse(JSON.stringify(this.detaislDataInfo))
                                    );
                                    return false;
                                }

                                // this.sendDataInfo.woApplyDetails[this.seIndex] = JSON.parse(JSON.stringify(val))
                                // }
                            })
                            .catch((rej) => {
                                this.lineMessageBox(rej);

                                this.$set(
                                    this.sendDataInfo.woApplyDetails,
                                    this.seIndex,
                                    JSON.parse(JSON.stringify(this.detaislDataInfo))
                                );
                                // this.$set(
                                // 	this.sendDataInfo.woApplyDetails[this.seIndex],
                                // 	"woadPnumber",
                                // 	''
                                // );
                            });
                        console.log(this.sendDataInfo.woApplyDetails);
                    } else if (this.seType == "recName") {
                        //收货员
                        this.$http
                            .checkRecSalesSale({
                                //校验收货员
                                formId: this.formDataList[0].jciId, //表单ID
                                salesId: val.salesId, //业务员ID
                            })
                            .then((res) => {
                                if (res && res.status == 200) {
                                    let flag = -1
                                    this.dialogList = res.result
                                    if (this.dialogList != null && this.dialogList.length > 0) {
                                        flag = this.dialogList.findIndex(item => item.level == 0)
                                        this.showDialog = true
                                    }
                                    if (flag == -1) {
                                        this.paramValue(val);
                                    }
                                } else {
                                    this.lineMessageBox(res);
                                    this.clearValue();
                                    return false;
                                }
                            })
                            .catch((rej) => {
                                this.lineMessageBox(rej);
                                this.clearValue();
                            });
                    } else if (this.seType == "ht") {
                        for (let key in val) {
                            this.sendDataInfo[key] = val[key];
                        }
                        this.parentSearchData.cmId = val.cmId;
                        this.sendDataInfo.woApplyDetails = [];
                    } else {
                        this.paramValue(val);
                    }
                    if (type == "salesName") {
                        //对方业务员
                        this.$http
                            .checkSalesSale({
                                //校验对方业务员
                                formId: this.formDataList[0].jciId, //表单ID
                                salesId: val.salesId, //业务员ID
                            })
                            .then((res) => {
                                if (res && res.status == 200) {
                                    let flag = -1
                                    this.dialogList = res.result
                                    if (this.dialogList != null && this.dialogList.length > 0) {
                                        flag = this.dialogList.findIndex(item => item.level == 0)
                                        this.showDialog = true
                                    }
                                    if (flag == -1) {
                                        this.paramValue(val);
                                    }
                                } else {
                                    this.lineMessageBox(res);
                                    this.clearValue();
                                    return false;
                                }
                            })
                            .catch((rej) => {
                                this.lineMessageBox(rej);
                                this.clearValue();
                            });
                    }
                });
            }
        },

        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        //确认新增
        async sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            if (this.sendDataInfo.woApplyDetails.length < 1) {
                this.$message({
                    message: "请添加明细",
                    type: "error",
                });
                return false;
            } else {
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    if (item.bgmId == "") {
                        this.sendDataInfo.woApplyDetails.splice(index, 1);
                    }
                });
            }
            if (this.sendDataInfo.orderId == "") {
                for (let j = 0; j < this.sendDataInfo.woApplyDetails.length; j++) {
                    const itemvs = this.sendDataInfo.woApplyDetails[j];
                    if (
                        itemvs.woadPnumber <= 0 ||
                        itemvs.woadPnumber > itemvs.saleableNum
                    ) {
                        this.$message({
                            message: "请填写商品、合理的销售数量",
                            type: "error",
                        });
                        this.$set(itemvs, "woadPnumber", 0);
                        return false;
                    }
                }
            }
            for (let key in this.sendDataInfo) {
                if (key == "") delete this.sendDataInfo[key];
            }
            this.sendDataInfo.totalCount=this.sendDataInfo.woApplyDetails.length
            let res = ""
            if (this.dataActionBox.actionType == 0) {//新增
                res = await this.$http.addXianXiaoGoods({
                    cmIntype: this.sendDataInfo.ssType == 0 ? this.sendDataInfo.cmIntype : '',
                    ssType: this.sendDataInfo.ssType,
                    cmId: this.sendDataInfo.ssType == 1 ? this.sendDataInfo.cmId : '',
                    detailList: this.sendDataInfo.woApplyDetails.map(item => {
                        let p = {
                            bgmId: item.bgmId,
                            dcNum: item.dcNum,
                            ycNum: item.ycNum
                        }
                        return p
                    })
                });
            } else if (this.dataActionBox.actionType == 1) {
                res = await this.$http.updateXianXiaoGoods({
                    cmIntype: this.sendDataInfo.ssType == 0 ? this.sendDataInfo.cmIntype : '',
                    ssType: this.sendDataInfo.ssType,
                    cmId: this.sendDataInfo.ssType == 1 ? this.sendDataInfo.cmId : '',
                    ssId: this.sendDataInfo.ssId,

                    detailList: this.sendDataInfo.woApplyDetails.map(item => {
                        let p = {
                            bgmId: item.bgmId,
                            dcNum: item.dcNum,
                            ycNum: item.ycNum
                        }
                        return p
                    })
                });
            }


            if (res.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                // this.$refs.operSelect.openBox(responseData.result);
                this.$emit("drawerCancel");
                this.init();
            } else {
                this.$message.error(res.message)
            }
        },
        drawerCancel() {
            this.$emit("drawerCancel", true);
        },
        conAdd() {

            this.init();
            // this.$refs["sendDataInfo"].resetFields();
            this.dataActionBox.actionType = 0;
        },
        //新增明细
        addDetail(sendDataInfo) {
            console.log(this.sendDataInfo.woApplyDetails);
            var flag = false
            if (this.sendDataInfo.woApplyDetails.length > 0) {
                this.sendDataInfo.woApplyDetails.forEach(item => {
                    if (item.bgmId == "") {
                        flag = true
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                })
            }
            if (flag) {
                return
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.woApplyDetails.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.woApplyDetails.push({})
                    var index = this.sendDataInfo.woApplyDetails.length - 1
                    for (const key in this.detaislDataInfo) {
                        this.$set(this.sendDataInfo.woApplyDetails[index], key, this.detaislDataInfo[key])
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.woApplyDetails.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        // 打开特价申请
        openPriceApplicationBox(goodsIndex = "") {

        },

        // 新增特价申请
        async addSpecialPriceApply() {

        },
        // 打开缺货登记
        openStockRegisterBox() {

        },

        // 新增缺货登记
        async addShortageRegistration() {
            if (this.stockRegisterData.wolrRegnumber == "") {
                this.$message({
                    message: "请先填写登记数量",
                    type: "error",
                });
                return false;
            }

            let responseData = await this.$http.addShortageRegistration(
                this.stockRegisterData
            );
            if (responseData.status == 200) {
                this.stockRegisterBox = false;
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 检测最低价
        async getGoodsSockPrice(goodsIndex) {

        },

        //含税价拦截
        doCheckPrice(cate, index) {

        },
        // 计算价格
        calculatePrice(cate = 1, index) {

        },

        //取消
        initActionBox(formName1, formName2) {
            console.log(this.dataActionBox.actionType);
            if (this.dataActionBox.actionType == 3) {
                this.$emit("drawerCancel");
            }else {
                this.$confirm(
                    "确定取消" + this.dataActionBox.boxTitle + "吗?",
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.$emit("drawerCancel");
                        this.init();
                        this.$refs[formName1].resetFields();
                        this.$refs[formName2].resetFields();
                    })
                    .catch(() => { });
            }

        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "woApplyDetails") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.ssType = 0
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();
            this.sendDataInfo.woApplyDetails = [];
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.orderType = 0; //orderType	订单类型0.药品订单1.器械订单
            this.checkIsBuyer();
        },

        // 选择业务员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.woamSalesman) {
                    this.sendDataInfo.depId = item.depId; //   业务部门
                    this.sendDataInfo.depName = item.depName; //   业务部门
                }
            });
        },
        initTime() {
            // this.getRequestData.start = this.$common.getStartTime()
            this.priceApplicationData.wosaEnddate = this.$common.getEndTime()
        },
        //上级流入
        openBox() {
            this.initTime()
            this.pageType = this.actionData.type;
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.showTabs = this.actionData.formData[0].jciName;

            var oldData = this.actionData.oldData;
            this.filterMainField();
            this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.initDefaultValue();
                this.checkIsBuyer();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                console.log(oldData)
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key])
                }
                this.sendDataInfo.woApplyDetails = oldData.detailList

                for (let key in this.sendDataInfo) {
                    if (this.sendDataInfo[key] == null) this.sendDataInfo[key] = "";
                }
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.sendDataInfo.woApplyDetails = oldData.detailList
            }
            this.$nextTick(() => {
                setTimeout(() => {
                        this.mxHeight = this.$common.getBtnHeight()
                    this.initFocus();
                }, 16.7)
            });
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();
        },

        //删除明细
        deleteDetails() {
            this.sendDataInfo.woApplyDetails.splice(this.selectedDetailsIndex, 1);
            this.$nextTick(() => {
                if (this.sendDataInfo.woApplyDetails.length > 1) {
                    this.selectedDetailsIndex = Number(
                        this.selectedDetailsIndex - 1
                    );
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                } else {
                    this.selectedDetailsIndex = 0;
                }
            });
        },

        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmSalesperson == 1) {
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
                this.tabForm[0].jurconfigform.forEach((item) => {
                    if (
                        item.entityField == "opmName" ||
                        item.entityField == "depName"
                    )
                        item.isChange = 0;
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach(item1 => {
                        if (item1.fieldType == 'number') {
                            this.$set(this.detaislDataInfo, item1.entityField, 0)
                        } else if (item1.fieldType == 'search' && item1.setField) {
                            var arr = item1.setField.split(',')
                            arr.forEach(item2 => {
                                this.$set(this.detaislDataInfo, item2, "")
                            })
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "")
                        }
                    })
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "woApplyDetails" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "woamSaledate", this.$moment().valueOf())
            this.$set(this.sendDataInfo, "orderType", 0)
            this.tabForm[0].jurconfigform.forEach(item => {
                if (item.entityField == 'cmIntype') {
                    item.isShow = 1
                } else if (item.entityField == 'cmName') {
                    item.isShow = 0
                }
            })
            this.mxForm.jurconfigform.forEach((item) => {
                if (item.entityField == "isTicket") {
                    this.ticket = item.defaultValue;
                }
            });
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
            this.$dbCache.Record_Get(4).then((res) => {
            //明细拦截
            let obj = res
            if (obj && obj.isEnable == 1) this.detailRules = true;
        });
        this.$nextTick(() => {
            this.openBox();

            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // addEventListener('keydown', this.keyDown)
        this.getlxList()
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}
</style>
<style>
.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>